module.exports = __webpack_public_path__ + "img/slide3.f9f7fb79.png";